import { memo } from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

/**
 * NoMatchMessage component displays a message when there are no matching notifications.
 *
 * This component utilizes the `useTranslation` hook to fetch the appropriate
 * translation for the message displayed to the user. It centers the message
 * both vertically and horizontally within a fixed height container.
 *
 * @returns {JSX.Element} The rendered NoMatchMessage component.
 */
function NoMatchMessage(): JSX.Element {
  const { t } = useTranslation('global');
  return (
    <div
      style={{
        height: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Typography variant="body1">
        {t('notifications.noCoincidences')}
      </Typography>
    </div>
  );
}

export default memo(NoMatchMessage);
